import { useTranslation } from 'react-i18next';
import { FiClipboard } from 'react-icons/fi';
import {
  DoctorInstructionDecidedNotificationType,
  DoctorInstructionSentNotificationType,
} from '../../types/notifications';
import { notificationSentAtFormattedDate } from '../../utils';

type DoctorInstructionNotificationCardProps = {
  notificationDetails: DoctorInstructionSentNotificationType | DoctorInstructionDecidedNotificationType;
  onClick: () => void;
};

const DoctorInstructionNotificationCard = ({
  notificationDetails,
  onClick,
}: DoctorInstructionNotificationCardProps) => {
  const { t } = useTranslation();

  return (
    <div
      onClick={onClick}
      className={`group relative flex gap-4 rounded-xl border p-6 transition-all hover:shadow-lg cursor-pointer ${
        notificationDetails.isRead ? 'border-gray-200 bg-white' : 'border-blue-200 bg-blue-50'
      }`}
    >
      {/* Icon */}
      <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-teal-100 text-teal-600">
        <FiClipboard size={24} />
      </div>

      {/* Content */}
      <div className="min-w-0 flex-1">
        <div className="mb-2 flex items-start justify-between gap-4">
          <div className="min-w-0 flex-1">
            <h3 className="mb-1 text-lg font-semibold text-gray-900">{notificationDetails.title}</h3>
            <p className="text-sm text-gray-600">{notificationDetails.message}</p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-4 flex items-center justify-between text-xs text-gray-500">
          <span>{notificationSentAtFormattedDate(notificationDetails.createdAt)}</span>
          {!notificationDetails.isRead && (
            <span className="rounded-full bg-blue-500 px-2 py-1 text-xs font-medium text-white">
              {t('notifications-new-badge')}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default DoctorInstructionNotificationCard;
